type DataLayer = {
    push: (data: unknown) => void
}

export function flagsTracking(
    flags: Record<string, boolean>,
    // Default to window.dataLayer but creates a seam for unit testing mocks
    dataLayer: DataLayer | undefined = (window as any).dataLayer,
) {
    const entries = Object.entries(flags)

    if (entries.length === 0) {
        return
    }

    const variantPairs = entries.map(([key, value]) => {
        return `${key}_${value ? 'b' : 'a'}`
    })

    dataLayer?.push({ event: 'user_test', variant: variantPairs.join(',') })
}
